import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './Styles/index.css';
import './Styles/bootstrap-override.scss';
/* import 'bootstrap/dist/css/bootstrap.min.css'; */
import 'bootstrap-icons/font/bootstrap-icons.css';
import { ThemeProvider } from 'react-bootstrap';
import { ModalProvider } from 'react-modal-hook';
import { ToastContainer } from 'react-toastify';
// import { TopLoadingBar } from './DataLoader';

// const clientID = '603655351602-58i3h2sbcn4f54mirg9to9oo7d77ma25.apps.googleusercontent.com';

// Create a client for TanStack Query (used by orval-generated hooks)
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            retry: 1
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <ThemeProvider breakpoints={['xxxxl', 'xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']} minBreakpoint="xs">
        {/* <TopLoadingBar /> */}
        <QueryClientProvider client={queryClient}>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
                <ModalProvider>
                    <App />
                </ModalProvider>
            </GoogleOAuthProvider>
        </QueryClientProvider>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            rtl={false}
            pauseOnFocusLoss
            closeOnClick={false}
            closeButton={true}
            draggable
            pauseOnHover
            theme="colored"
        />
    </ThemeProvider>
);
